var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 51.3933V12.5C50 9.84784 48.9464 7.3043 47.0711 5.42893C45.1957 3.55357 42.6522 2.5 40 2.5C37.3478 2.5 34.8043 3.55357 32.9289 5.42893C31.0536 7.3043 30 9.84784 30 12.5V51.3933C27.7357 53.4186 26.1397 56.0836 25.4232 59.0358C24.7067 61.988 24.9034 65.0881 25.9874 67.926C27.0714 70.7639 28.9915 73.2058 31.4937 74.9285C33.9958 76.6513 36.9621 77.5737 40 77.5737C43.0379 77.5737 46.0042 76.6513 48.5063 74.9285C51.0085 73.2058 52.9286 70.7639 54.0126 67.926C55.0966 65.0881 55.2933 61.988 54.5768 59.0358C53.8603 56.0836 52.2643 53.4186 50 51.3933Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.5V57.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67.5C42.7614 67.5 45 65.2614 45 62.5C45 59.7386 42.7614 57.5 40 57.5C37.2386 57.5 35 59.7386 35 62.5C35 65.2614 37.2386 67.5 40 67.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfection);
export default __webpack_public_path__ + "static/media/infection.2f056497327857d24e0b67214fb3028f.svg";
export { ForwardRef as ReactComponent };